"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constellation_1 = require("@zillow/constellation");
const react_1 = __importStar(require("react"));
const parseRatesData_1 = __importDefault(require("../../utils/data/parseRatesData"));
const RateCardsContainerTabbed_1 = __importDefault(require("./RateCardsContainerTabbed"));
const RateCardsContainer_1 = __importDefault(require("./RateCardsContainer"));
const RateCardsCarousel_1 = __importDefault(require("./RateCardsCarousel"));
const CardsContext_1 = __importDefault(require("../../context/CardsContext"));
const RateCards = () => {
    var _a;
    const { data, tabbed } = (0, react_1.useContext)(CardsContext_1.default);
    function getData() {
        const { lastUpdate, parsedData } = (0, parseRatesData_1.default)(data);
        const lastDate = new Date(lastUpdate).toLocaleDateString();
        const cardsInfo = parsedData;
        return { cardsInfo, lastDate };
    }
    const { cardsInfo, lastDate } = getData();
    return (react_1.default.createElement(constellation_1.Box, null,
        react_1.default.createElement(constellation_1.Box, { sx: {
                display: 'block',
                '@media $sm_lte': { display: 'none' },
            } }, tabbed ? (react_1.default.createElement(RateCardsContainerTabbed_1.default, { cardsInfo: cardsInfo })) : (react_1.default.createElement(RateCardsContainer_1.default, { cardsInfo: ((_a = cardsInfo[0]) === null || _a === void 0 ? void 0 : _a.data) || [] }))),
        react_1.default.createElement(constellation_1.Box, { sx: {
                display: 'none',
                '@media $sm_lte': { display: 'block' },
            } },
            react_1.default.createElement(RateCardsCarousel_1.default, { cardsInfo: cardsInfo })),
        react_1.default.createElement(constellation_1.Flex, { display: {
                default: 'flex',
                lg_lte: 'none',
            }, justifyContent: "center", marginTop: "md" },
            react_1.default.createElement(constellation_1.Text, { fontColor: "textDark", fontType: "h6" },
                "Last updated: ",
                lastDate))));
};
exports.default = RateCards;
